<template>
  <div
    class="newsletter-form-component has-text-centered-mobile has-text-light"
  >
    <p class="title is-size-6 has-margin-top-5 has-text-light">
      Stay Up to Date.
    </p>
    <p class="subtitle is-size-6 has-margin-top-5 has-text-grey-lighter">
      Join our newsletter for updates.
    </p>
    <form action="https://formspree.io/info@crowdflik.com" method="POST">
      <b-field>
        <b-input
          v-model="email"
          placeholder="Enter your email address"
          type="email"
          name="subscriber_email"
          expanded
        ></b-input>
        <p class="control">
          <input
            class="button is-fullwidth"
            type="submit"
            value="Send"
            v-bind:class="buttonClass"
          />
        </p>
      </b-field>
      <p class="is-size-7 has-text-grey-light">
        We will not share or sell this information with anyone, and you can
        unsubscribe at any time.
      </p>
    </form>
  </div>
</template>

<script>
export default {
  name: "NewsletterForm",
  data() {
    return {
      email: null
    };
  },
  computed: {
    buttonClass: function() {
      if (this.email) {
        return {
          "is-static": false,
          "is-success": true
        };
      } else {
        return {
          "is-static": true,
          "is-success": false
        };
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
